module.exports = __webpack_public_path__ + "img/arrow-down.98f0fd66.svg";